import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Collapse } from "reactstrap";
import config from "../../config";
import { useProfile } from "../../contexts/ProfileContext";
import "react-toastify/dist/ReactToastify.css";
import Brand_icon from "../../assets/images/Brand_icon.png";

import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

import "./leftSidebar.css";
import UserProfile from "./UserProfile";
import { Avatar } from "@mui/material";
import { MdArrowOutward, MdVerified } from "react-icons/md";
import { FaHourglassHalf } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { IoClose } from "react-icons/io5";

// Sidebar Icons
import FindPropertiesIcon from "../../assets/images/sidebar-imgs/find-prop.svg";
import MyPropertiesIcon from "../../assets/images/sidebar-imgs/listed.svg";
import ChatIcon from "../../assets/images/sidebar-imgs/chat.svg";
import TemplatesIcon from "../../assets/images/sidebar-imgs/templates.svg";
import DocsIcon from "../../assets/images/sidebar-imgs/docs.svg";
import FavoritesIcon from "../../assets/images/sidebar-imgs/favorites.svg";
import ServicesIcon from "../../assets/images/sidebar-imgs/Services.svg";

function LeftSidebarMenu({ isExpanded, setIsExpanded, drawerOpen, setDrawerOpen, sidebarRef }) {
    const modalRef = useRef(null);
    const { profileData, setProfileData } = useProfile();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState("");

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalRef]);

    const logout = () => {
        // Clear tokens from both localStorage and sessionStorage
        localStorage.removeItem("authUser");
        localStorage.removeItem("refreshToken");
        sessionStorage.removeItem("authUser");
        sessionStorage.removeItem("refreshToken");
        localStorage.clear();
        sessionStorage.clear();
        setProfileData({}); // Clear profile data in Context
        navigate("/login");
    };

    const toggleDrawer = () => {
        setDrawerOpen((prev) => !prev);
    };

    useEffect(() => {
        // Profile data will be fetched by the ProfileProvider
    }, [profileData]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalRef, sidebarRef]);

    const handleButtonClick = () => {
        toggleDrawer();
        navigate("/list-property/welcome");
    };

    const handleMenuClick = (menu) => {
        toggleDrawer();
        setActiveMenu(menu);
        // navigate("/favorites");
    };

    const pathsToCheck = [
        "/services/financing",
        "/get-qualified/Step-1",
        "/get-qualified/Step-2",
        "/get-qualified/Step-3",
        "/get-qualified/Step-4",
        "/get-qualified/Step-5",
        "/get-qualified/Step-6",
        "/get-qualified/Step-7",
        "/get-qualified/success",
        "/sell",
    ];
    useEffect(() => {
        const currentPath = location.pathname;
        if (pathsToCheck.some((path) => currentPath.includes(path))) {
        } else {
        }
    }, [location.pathname]);
    const truncateName = (name = "") => {
        return name.length > 13 ? name.slice(0, 13) + "..." : name;
    };
    const renderProfilePicture = (profile_pic) => {
        if (profile_pic && profile_pic?.startsWith("http")) {
            return profile_pic;
        } else if (profile_pic.startsWith("/public/images")) {
            return "https://image.onmls.com" + profile_pic;
        } else {
            return `https://image.onmls.com/public/images/${profile_pic}`;
        }
    };
    return (
        <div className="tw-relative tw-h-full tw-flex tw-flex-col">
            {/* Fixed Header Section - Hidden on mobile, MobileHeader handles mobile header */}
            <div className="tw-sticky tw-top-0 tw-left-0 tw-w-full tw-z-[1060] tw-bg-tertiary tw-flex-shrink-0 max-sm:tw-hidden">
                <div className="tw-h-[55px] tw-w-full tw-flex tw-justify-center tw-items-center">
                    <div className="tw-flex tw-justify-between">
                        <div className="logoWrapper">
                            <img src={Brand_icon} alt="AiRE BROKERS logo" className="logo tw-w-[35px] tw-h-[35px]" />
                            <span className={`brandName tw-text-[18px] ${isExpanded ? "" : "tw-hidden"}`}>{config.get("COMPANY_NAME")}</span>
                        </div>
                    </div>
                </div>
            </div>

            <nav
                ref={sidebarRef}
                className={`sidebar tw-flex tw-flex-col tw-justify-between tw-flex-1 tw-bg-white tw-pb-1 tw-overflow-y-auto tw-overflow-x-hidden tw-left-0 tw-top-0 tw-z-[1050] max-sm:tw-z-[50000] ${!isExpanded ? "tw-px-2" : "tw-px-4"} ${drawerOpen ? "open" : "closed"} tw-transition-all tw-duration-300 md:tw-static md:tw-w-full`}
            >
                <div className="tw-flex-1">
                    {/* Mobile close button - only visible when sidebar is open */}
                    {drawerOpen && (
                        <button
                            onClick={toggleDrawer}
                            className="md:tw-hidden tw-absolute tw-top-4 tw-right-4 tw-p-2 tw-text-gray-800 hover:tw-text-gray-600 tw-z-[50002] tw-opacity-100 tw-bg-white tw-rounded-full tw-shadow-lg"
                            style={{ opacity: 1 }}
                            aria-label="Close menu"
                        >
                            <IoClose size={28} color="#000" />
                        </button>
                    )}
                    <div className={`tw-flex tw-flex-col tw-mt-3`}>
                        <NavLink
                            to="/properties"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("properties")}
                        >
                            <img src={FindPropertiesIcon} alt="Find Properties" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Find Properties</span>
                        </NavLink>

                        <NavLink
                            to="/MyProperties"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("myProperties")}
                        >
                            <img src={MyPropertiesIcon} alt="My Properties" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span style={{}} className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>
                                My Properties
                            </span>
                        </NavLink>

                        <NavLink
                            to="/favorites"
                            className={({ isActive }) => {
                                return `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`;
                            }}
                            onClick={() => handleMenuClick("favorites")}
                        >
                            <img src={FavoritesIcon} alt="Favorites" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Favorites</span>
                        </NavLink>

                        <NavLink
                            to="/chat"
                            className={({ isActive }) => {
                                const isCurrentlyActive = isActive && location.search.includes("chat_id");

                                return `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isCurrentlyActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`;
                            }}
                            onClick={() => handleMenuClick("chat")}
                        >
                            <img src={ChatIcon} alt="Chat" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Chat</span>
                        </NavLink>

                        <NavLink
                            to="/documents/templates"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("templates")}
                        >
                            <img src={TemplatesIcon} alt="Templates" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Templates</span>
                        </NavLink>

                        <NavLink
                            to="/users/docs"
                            className={({ isActive }) =>
                                `nav-linke max-lg:tw-gap-[7px] hover:tw-text-secondary tw-no-underline  ${isActive ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`
                            }
                            onClick={() => handleMenuClick("userDocuments")}
                        >
                            <img src={DocsIcon} alt="User Documents" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>User Documents</span>
                        </NavLink>

                        <NavLink
                            to="#"
                            onClick={toggleDropdown}
                            className={`nav-linke max-lg:tw-gap-[7px] tw-text-center hover:tw-text-secondary tw-no-underline  ${activeMenu === "insuranceQuote" || activeMenu === "financing" || activeMenu === "titleServices" || activeMenu === "homeInspector" ? "nav-linke-active tw-text-secondary tw-border-[1px] tw-border-secondary" : ""}`}
                        >
                            <img src={ServicesIcon} alt="Services" className={`tw-w-[20px] tw-h-[20px] max-lg:tw-w-[18px] max-lg:tw-h-[18px] ${!isExpanded && "tw-mx-auto"}`} />
                            <span className={`tw-text-[16px] max-lg:tw-text-[14px] ${isExpanded ? "" : "tw-hidden"}`}>Services</span>
                            <span className={`${isExpanded ? "" : "tw-hidden"} tw-ml-auto`}>
                                {isOpen ? <KeyboardArrowUpOutlinedIcon className="text-[#001659]" /> : <KeyboardArrowDownOutlinedIcon />}
                            </span>
                        </NavLink>

                        <Collapse isOpen={isOpen}>
                            <div className=" tw-flex tw-flex-col  tw-pb-1 tw-rounded-lg tw-mt-1">
                                <NavLink
                                    to="/services/financing"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("financing")}
                                >
                                    Financing
                                </NavLink>
                                <NavLink
                                    to="/services/insurance-quote"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("insuranceQuote")}
                                >
                                    Insurance Quote
                                </NavLink>
                                <NavLink
                                    to="/services/title-services"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("titleServices")}
                                >
                                    Title Services
                                </NavLink>
                                <NavLink
                                    to="/services/home-Inspection"
                                    className={` ${isExpanded ? "" : "tw-hidden"} font-roboto font-normal font-medium tw-pl-9 text-[10px]  2xl:tw-text-[13px] between:tw-text-[14px] leading-[19px] text-black tw-flex tw-gap-2 tw-px-1 tw-text-[11px] tw-items-center tw-py-[2px] tw-mb-1.5 tw-rounded hover:tw-active-link`}
                                    onClick={() => handleMenuClick("homeInspector")}
                                >
                                    Home Inspection
                                </NavLink>
                            </div>
                        </Collapse>

                        {/* Ready To Sell Card */}
                        <div className={`tw-flex tw-w-full tw-justify-center tw-my-4`}>
                            <div className={`${isExpanded ? "" : "tw-hidden"} sidebar-list-bg tw-bg-[#0f172a] tw-w-full tw-p-3 tw-rounded-xl`}>
                                <div className="tw-text-center">
                                    <p className="tw-text-white tw-font-semibold tw-text-[20px] max-lg:tw-text-[16px] tw-mb-1">Ready To Sell?</p>
                                    <p className="tw-text-white tw-text-[11px] tw-leading-4">Use our advanced AI to sell your home fast, no commissions!</p>
                                </div>
                                <button
                                    onClick={handleButtonClick}
                                    className="tw-bg-[#208177] tw-text-white hover:tw-bg-[#1B6D6E] tw-font-bold tw-w-full tw-py-2 tw-text-[18px] max-lg:tw-text-[14px] tw-rounded-md tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mt-3 tw-transition-colors tw-duration-200"
                                >
                                    List Now
                                    <MdArrowOutward />
                                </button>
                            </div>
                            <button
                                onClick={handleButtonClick}
                                className={`${!isExpanded ? "" : "tw-hidden"} tw-text-[12px] tw-bg-secondary tw-text-white hover:tw-text-white hover:tw-bg-secondary_hover tw-font-Space_Grotesk tw-font-[400] tw-w-full tw-p-1 tw-rounded-md tw-flex tw-items-center tw-gap-1 tw-justify-center`}
                            >
                                List Now
                            </button>
                        </div>
                    </div>
                </div>

                {/* User Profile Section - Bottom */}
                <div className="tw-mt-auto tw-border-t tw-border-gray-200 tw-pt-4">
                    <div className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-3`}>
                        {profileData?.profile_pic ? (
                            <Avatar
                                src={renderProfilePicture(profileData?.profile_pic)}
                                alt="User profile"
                                className="tw-shadow-md tw-border-2 tw-border-gray-200"
                                sx={{ width: 50, height: 50 }}
                            />
                        ) : (
                            <div className="tw-w-[50px] tw-h-[50px] tw-rounded-full tw-bg-[#208177] tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold tw-text-xl tw-border-2 tw-border-gray-200">
                                {profileData?.first_name?.charAt(0).toUpperCase()}
                                {profileData?.last_name?.charAt(0).toUpperCase()}
                            </div>
                        )}

                        <div className={`tw-flex tw-items-center tw-gap-2 tw-mt-2 ${!isExpanded && "tw-hidden"}`}>
                            <p className="tw-font-semibold tw-text-sm">
                                {truncateName(profileData?.first_name)} {truncateName(profileData?.last_name)}
                            </p>
                            {profileData?.verification_status === "approved" ? (
                                <span>
                                    <MdVerified color="#2bba00" size={20} />
                                </span>
                            ) : profileData?.verification_status === "pending" ? (
                                <span>
                                    <FaHourglassHalf color="#F2C94C" size={16} />
                                </span>
                            ) : profileData?.verification_status === "rejected" ? (
                                <span>
                                    <FcCancel color="red" size={20} />
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className={`tw-flex tw-justify-center tw-pb-3 tw-px-2`}>
                        <button
                            onClick={logout}
                            className={`tw-border tw-border-[#E74C3C] tw-rounded-md tw-py-[7px] tw-px-10 tw-text-[#E74C3C] tw-font-bold tw-text-[14px] tw-bg-transparent hover:tw-bg-[#E74C3C] hover:tw-text-white tw-transition-colors tw-cursor-pointer ${!isExpanded && "tw-px-4"}`}
                        >
                            Log out
                        </button>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default LeftSidebarMenu;
